module.exports = __webpack_public_path__ + "img/4,w_1126.ff30ad7a.jpg";